// /account/logout — idempotent local logout.
// Contract (PROMPT FIX-LOGOUT):
//   - POST /api/account/logout once, credentials:'include'.
//   - Never navigate to the auth provider. Never open a beacon. Never <img>.
//   - After POST resolves (or fails), do a same-origin nav to '/'.
//   - This page has NO side effects on mount other than the logout POST;
//     it never triggers /api/account/me.

import { useEffect, useRef } from 'react';
import { ACCOUNT } from '../../constants/testIds';
import { API_BASE } from '../../lib/apiBase';

const BACKEND = API_BASE;

export default function AccountLogout() {
        const fired = useRef(false);
        useEffect(() => {
                if (fired.current) return;
                fired.current = true;
                (async () => {
                        try {
                                await fetch(`${BACKEND}/api/account/logout`, {
                                        method: 'POST',
                                        credentials: 'include',
                                });
                        } catch {
                                /* swallow — spec: fetch resolves or catches, then navigate */
                        }
                        window.location.replace('/');
                })();
        }, []);
        return (
                <main
                        data-testid={ACCOUNT.logoutPage}
                        className="min-h-screen bg-[#0A0A0A] text-white flex items-center justify-center"
                >
                        <p className="font-mono text-[12px] tracking-[0.2em] text-white/50 uppercase">
                                Signing out…
                        </p>
                </main>
        );
}
